import React, { useEffect, useState } from 'react'
import { DatePicker, Input, Select } from 'antd';
import './leaveManagement.scss';
import LeaveReportTable from './LeaveReportTable';
import { useSelector, useDispatch } from 'react-redux';
import { ErrorMessages, triggerNotification, useGetApiRequests } from '../../common/CommonExport';
import { Dayjs } from 'dayjs';
import { employeeTypeList, statusList } from './LeavePolicyForms/LeaveReportConstants';
import { setLeaveReportPayload } from '../../redux/slices/leaveReportPayloadSlice';
import ModalLoader from '../../components/Loader/ModalLoader';
import { setLeaveReportTotal } from '../../redux/slices/leaveListSlice';

export default function LeaveReport() {

  const { RangePicker } = DatePicker;
  const leaveList = useSelector((state: any) => state?.leaveList?.leaveList);
  const designationDepartmentApi = useGetApiRequests('designationDepartmentList', 'GET');
  const getLeaveReportsApi = useGetApiRequests('getLeaveReport', 'GET');
  const leavePloicyApi = useGetApiRequests('getLeavePolicy', 'POST');
  const orgId = useSelector((state: any) => state?.organisationId?.id);
  const dispatch = useDispatch();
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
  const [departmentList, setDepartmentList] = useState([])
  const [loader, setLoader] = useState(true);
  const [employeeName, setEmployeeName] = useState('')
  const [leaveType, setLeaveType] = useState('')
  const [department, setDepartment] = useState('')
  const [statusType, setStatusType] = useState('')
  const [employeeType, setEmployeeType] = useState('')
  const [pickerValue, setPickerValue] = useState<[Dayjs, Dayjs] | null>(null);
  const [dateStart, setDateStart] = useState('')
  const [dateEnd, setDateEnd] = useState('');
  const [leavePolicyReports, setLeavePolicyReports] = useState<any>([])
  const [isSubmit, setIsSubmit] = useState(false)
  const [isClear, setIsClear] = useState(false)
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [count, setCount] = useState<number>(0);
  const [pageSize, setPageSize] = useState(10);

  const handleRangePickerChange = (dates: [Dayjs, Dayjs] | null, dateStrings: [string, string]) => {
    if (!dates) {
      setDateStart('');
      setDateEnd('');
      return;
    }
    const [startDate, endDate] = dates;
    setDateStart(startDate.format('YYYY-MM-DD'));
    setDateEnd(endDate.format('YYYY-MM-DD'));
  };
  const addQueryParam = (queryParams: any, key: string, value: string | undefined, transform?: (val: string) => any) => {
    if (value && value !== '') {
      queryParams[key] = transform ? transform(value) : value;
    }
  };
  const regularDateFormat = (input_value: any) => {
    const apiDate = new Date(input_value);
    const year = apiDate.getFullYear();
    const month = String(apiDate.getMonth() + 1).padStart(2, "0");
    const day = String(apiDate.getDate()).padStart(2, "0");

    const result = `${day}.${month}.${year}`;
    return result;
  }

  const formatLeaveTypeName = (leaveTypeName: string | null | undefined): string => {
    if (!leaveTypeName) return '';
    const normalizedLeaveType = leaveTypeName.trim().toUpperCase();
    if (normalizedLeaveType === 'WFH') return 'Work From Home';
    return leaveTypeName;
  };

  const getLeavePolicyApi = () => {

    setLoader(true);
    const payload = {
      searchLeavePolicyDto: {
        organisationId: orgId
      },
      start: 0,
      limit: 50,
    }
    leavePloicyApi(payload)
      .then((response: any) => {
        setLoader(true)
        const leavesWeCantTake = response?.data?.data.map((item: any, index: number) => ({
          leavePolicyMappingId: item?.leavePolicyMappingId,
          leavePolicy: item?.leavePolicy?.policyName,
          key: item?.leavePolicy?.leavePolicyId,
          checked: false
        }));
        const reformedLeaveType = leavesWeCantTake.map((item: any) => ({
          value: item?.key,
          label: formatLeaveTypeName(item?.leavePolicy)
        }));


        setLeaveTypeOptions(reformedLeaveType);
        setTimeout(() => {
          setLoader(false)
        }, 2000)
      })
      .catch((err: any) => {
        setTimeout(() => {
          setLoader(false)
        }, 2000)
        triggerNotification('error', '', err?.message, 'topRight');
      });
  };

  const onShowSizeChange = (currentPage: number, newSize: number) => {
    setPageSize(newSize);
    setCurrentPage(1);
  };

  const handlePaginationChange = (pageNumber: number, pageSize: number) => {
    let currentPage = pageNumber - 1;
    const pageSizeValue: number = pageSize ?? 1;
    let finalPage = 1;
    if (currentPage > 0) {
      finalPage = currentPage * pageSizeValue;
    } else if (currentPage === 0) {
      finalPage = 0;
    }
    setCurrentPage(pageNumber);
    setPageSize(pageSize);
    getLeaveReport(finalPage, pageSize)
  };
  const handleSubmit = () => {
    setIsSubmit(true)
    setCurrentPage(0);
    setPageSize(10);
    getLeaveReport(0, 10)
  }

  const hasFilters =
    employeeName !== "" ||
    leaveType !== undefined ||
    department !== undefined ||
    statusType !== undefined ||
    employeeType !== undefined ||
    dateStart !== undefined ||
    dateEnd !== undefined;

  const getLeaveReport = (currentPage: number, pageSize: number) => {
    setLoader(true);
    const queryParams: any = {
      organisationId: orgId,
      start: currentPage,
      limit: pageSize,
    }
    addQueryParam(queryParams, 'employeeName', employeeName);
    addQueryParam(queryParams, 'leavePolicyId', leaveType, parseInt);
    addQueryParam(queryParams, 'departmentId', department, parseInt);
    addQueryParam(queryParams, 'leaveStatus', statusType);
    addQueryParam(queryParams, 'employementTypeId', employeeType, parseInt);
    addQueryParam(queryParams, 'fromDate', dateStart);
    addQueryParam(queryParams, 'toDate', dateEnd);

    dispatch(setLeaveReportPayload(queryParams));
    getLeaveReportsApi('', queryParams)
      .then((response: any) => {
        const totalRecords = response?.data?.meta?.totalRecords
        setCount(totalRecords)
        dispatch(setLeaveReportTotal(totalRecords))
        const reformedLeaveReports = response?.data?.data.map((item: any, index: number) => ({
          policyType: formatLeaveTypeName(item?.policyType),
          employeeName: item?.employeeName,
          fromDate: item?.fromDate,
          toDate: item?.toDate,
          duration: item?.duration,
          status: item?.status,
          reason: item?.reason,
          key: index + 1,
          formattedFromDate: regularDateFormat(item?.fromDate),
          formattedToDate: regularDateFormat(item?.toDate),
          lopCount: item?.lopCount
        }));


        setLeavePolicyReports(reformedLeaveReports);
        setTimeout(() => {
          setLoader(false)
        }, 2000)
      })
      .catch((err: any) => {
        triggerNotification('error', '', err?.message, 'topRight');
        setTimeout(() => {
          setLoader(false)
        }, 2000)
      });
  }
  const handleClear = () => {
    setEmployeeName('');
    setLeaveType('');
    setDepartment('');
    setStatusType('');
    setEmployeeType('');
    setDateStart('');
    setDateEnd('');
    setPickerValue(null);
    setIsSubmit(false)
    setIsClear(!isClear)
  }
  useEffect(() => {
    getLeavePolicyApi()
    departmentGetListApi()
    getLeaveReport(0, 10)
  }, [isClear]);

  const departmentGetListApi = () => {
    const params: any = {
      organisationId: orgId,
    };
    setLoader(true);
    designationDepartmentApi('', params)
      .then((response: any) => {
        const reformedDepartmentsList = response?.data?.data.map((item: any) => ({
          value: item.departmentId,
          label: item.name,
        }));
        setDepartmentList(reformedDepartmentsList);
        setTimeout(() => {
          setLoader(false)
        }, 1500)
      })
      .catch((err: any) => {
        triggerNotification('error', '', err?.message, 'topRight');
        setTimeout(() => {
          setLoader(false)
        }, 1500)
      });
  };
  return (
    <div className='leave-report w-full overflow-x-auto'>
      <div className='grid grid-cols-7  gap-2 mb-6'>
        <div>
          <p className='text-[#D34A7C] font-bold'>Employee name</p>
          <Input placeholder="Employee name" value={employeeName} onChange={(e: any) => setEmployeeName(e.target.value)} />
        </div>
        <div>
          <p className='text-[#D34A7C] font-bold'>Types</p>
          <Select className='w-full' options={leaveTypeOptions} placeholder={"Types"} value={leaveTypeOptions.filter((item: any) => item.value === leaveType)} onChange={(value: any) => setLeaveType(value)}></Select>
        </div>
        <div >
          <p className='text-[#D34A7C] font-bold'>Date of Leave & On Duty</p>
          <RangePicker data-testid="pickerEl"
            value={pickerValue}
            onChange={(dates: any, dateStrings: any) => {
              handleRangePickerChange(dates, dateStrings);
              setPickerValue(dates);
            }}
          />
        </div>
        <div >
          <p className='text-[#D34A7C] font-bold'>Department</p>
          <Select className='w-full' options={departmentList} placeholder={'Select Department'} value={departmentList.filter((item: any) => item.value === department)} onChange={(value: any) => setDepartment(value)}></Select>
        </div>
        <div >
          <p className='text-[#D34A7C] font-bold'>Status</p>
          <Select className='w-full' options={statusList} placeholder={'Select Status'} value={statusList.filter((item: any) => item.value === statusType)} onChange={(value: any) => setStatusType(value)}></Select>
        </div>
        <div >
          <p className='text-[#D34A7C] font-bold'>Employee type</p>
          <Select className='w-full' options={employeeTypeList} placeholder={'Employee Type'} value={employeeTypeList.filter((item: any) => item.value === employeeType)} onChange={(value: any) => setEmployeeType(value)}></Select>
        </div>
        <div className='flex items-center pt-3'>
          <div className=' mr-1'>
            <button type='button' className='  secondary clear-filter' onClick={handleClear} >Clear filter</button>
          </div>
          <div >
            <button type='submit' className='addButton  primary pr-1 ' onClick={handleSubmit}>Submit</button>
          </div>
        </div>
      </div>
      <LeaveReportTable leavePolicyReports={leavePolicyReports} isSubmit={isSubmit} loader={loader} currentPage={currentPage} setCurrentPage={setCurrentPage} pageSize={pageSize} setPageSize={setPageSize} count={count} onShowSizeChange={onShowSizeChange} getLeaveReport={getLeaveReport} handlePaginationChange={handlePaginationChange} hasFilters={hasFilters} />
    </div>
  )
}
